import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// security rules are maintained in firebase console
const firebaseConfig = {
    apiKey: "AIzaSyBjdlegbBaIZ0Bt9-K-Ow0YxJJPFVDR6mo",
    authDomain: "joynet-99b18.firebaseapp.com",
    projectId: "joynet-99b18",
    storageBucket: "joynet-99b18.firebasestorage.app",
    messagingSenderId: "399319880222",
    appId: "1:399319880222:web:2932b1671e610b541e140f",
    measurementId: "G-5R0V18NR8T"
  };

const app = initializeApp(firebaseConfig);

// Export Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;

// can add in other firebase functions here